import React, { FC } from "react";
import { Element } from "../../models/elementModel";
import RadioBtnElement from "../elementComponents/renderElementComponents/RadioButtonElement";
import ButtonProperties from "./elements/buttonElementProperties";
import CollapseElementProperties from "./elements/collapseElementProperties";
import DropdownProperties from "./elements/dropdownElementProperties";
import HeadingProperties from "./elements/headingElementProperties";
import ImageProperties from "./elements/imageElementProperties";
import InputElementProperties from "./elements/inputElementProperties";
import LabelProperties from "./elements/labelElementProperties";
import NavigationProperties from "./elements/navigation/navigationProperties";
import RadioProperties from "./elements/radioBtnElementProperties";
import TabFormElementProperties from "./elements/tabElementProperties";
import TableElementProperties from "./elements/tableElementProperties";
import TextAreaProperties from "./elements/textAreaElementProperties";
import TypographyElementProperties from "./elements/typographyElementProperties";
import VideoEmbedProperties from "./elements/videoEmbedProperties";
import CarouselElementProperties from "./elements/carouselElementProperties";

export interface RenderPropertiesProps {
  element: Element;
}

const RenderProperties: FC<RenderPropertiesProps> = ({ element }) => {
  switch (element.type) {
    case "input":
    case "file":
      return <InputElementProperties element={element} />;
    case "txtarea":
      return <TextAreaProperties element={element} />;
    case "dropdown":
      return <DropdownProperties element={element} />;
    case "btn":
      return <ButtonProperties element={element} />;
    case "heading":
      return <HeadingProperties element={element} />;
    case "lbl":
      return <LabelProperties element={element} />;
    case "rdioBtn":
      return <RadioProperties element={element} />;
    case "chkBox":
      return <RadioProperties element={element} />;
    case "img":
      return <ImageProperties element={element} />;
    case "tab":
      return <TabFormElementProperties element={element} />;
    case "navbar":
      return <NavigationProperties element={element} />;
    case "table":
      return <TableElementProperties element={element} />;
    case "collaps":
      return <CollapseElementProperties element={element} />;
    case "video":
    case "map":
      return <VideoEmbedProperties element={element} />
    case "typography":
        return <TypographyElementProperties element={element} />
    case "carousel":
        return <CarouselElementProperties element={element} />
    default:
      return null;
  }
};

export default RenderProperties;
